import { observable, action } from 'mobx';

export default class TakeOffStore {
  @observable count = 20;

  @observable skipOver = false;

  @action reset() {
    this.count = 20;
    this.skipOver = false;
  }
}

export const takeOffStore = new TakeOffStore();
